import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import styled from "styled-components";

import type { BannerTheme, NotificationType } from "./types";

export const NotificationBannerTheme: Record<NotificationType, BannerTheme> = {
    warning: {
        backgroundColor: colorsPalettes.yellow[100],
        iconName: "warning",
        iconColor: colorsPalettes.yellow[600],
    },
    questions: {
        backgroundColor: colorsPalettes.carbon[25],
        iconName: "questions",
        iconColor: colorsPalettes.carbon[400],
    },
};

export const StyledNotificationBanner = styled(FlexRow)<{ theme: BannerTheme }>`
    align-items: center;
    height: 48px;
    padding: 6px 16px 6px 12px;

    box-sizing: border-box;
    background-color: ${({ theme }) => theme.backgroundColor};
    border-radius: 4px;
`;

export const StyledIcon = styled(SWReactIcons)<{ theme: BannerTheme }>`
    margin-right: 8px;
    min-width: 16px;

    & svg path {
        fill: ${({ theme }) => theme.iconColor};
    }
`;
